<style lang="scss" scoped>
.news-card {
  display: flex;
  flex-flow: column;
  transition: border-color 0.15s ease-in-out;
  height: 100%;
  &:hover {
    border-color: #000000;
  }
  img {
    width: 100%;
    height: 186px;
    flex: none;
    object-fit: cover;
  }
  .content {
    padding: 16px;
    height: 100%;
    h4 {
      letter-spacing: 0;
      line-height: 27px;
      margin-bottom: 24px;
      color: #000000;
      font-family: 'Montserrat';
      text-transform: inherit;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 1px;
      line-height: 28px;
    }
    p {
      color: #6b6667;
      font-family: Montserrat;
      font-size: 15px;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: normal;
    }
  }
}
</style>

<template>
  <div>
    <a v-if="data" class="news-card" :href="route(computedUrl, ...computedUrlParams)">
      <img class="dynamic-image" data-object-fit="cover" :src="data.afbeelding.guid" :alt="`${data.title.rendered} | Vastgoed C`" />
      <div class="content d-flex flex-column justify-content-between">
        <h4 v-html="data.title.rendered"></h4>
        <p  :inner-html.prop="data.intro | truncate(500, '...')"></p>
        <div>
          <button class="btn btn-cyan">Lees meer</button>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
    },
    url: {
      default: 'blog-show',
    },
    urlParams: {
      default: () => {},
    },
  },
  data() {
    return {
      computedUrl: '',
      computedUrlParams: {},
    };
  },
  mounted() {
    if (!this.url) this.computedUrl = 'blog-show';
    else this.computedUrl = this.url;

    if (!this.urlParams) this.computedUrlParams = { slug: this.data.slug, newsSlug: this.data.slug };
    else this.computedUrlParams = { ...this.urlParams, newsSlug: this.data.slug };
  },
  filters: {
    truncate: function(text, length, suffix) {
      if (text.length > length) {
        return text.replace(/<[^>]*>?/gm, '').substring(0, length) + suffix;
      } else {
        return text.replace(/<[^>]*>?/gm, '');
      }
    },
  },
};
</script>
